// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"20790f33","419":"8d325a5d","645":"c4fa602d","676":"fe741cc7"}[chunkId] + ".chunk.css";
};